import React from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import WriteoffDashboardCard, { WriteoffStatusSummary } from './WriteoffDashboardCard';
import { useWriteoffDashboardData } from '../../hooks';

export const WriteoffDashboardLayout: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  const center = searchParams.get('center') || '';

  // Get dashboard data
  const { summaries } = useWriteoffDashboardData(company, center);

  return (
    <Box>
      {/* Professional Card Layout - Responsive Grid */}
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: 'auto auto',
        columnGap: 2,
        rowGap: 4,
        '& > :nth-of-type(n+5)': {
          gridColumn: 'span 1'
        },
        '& > :nth-of-type(5)': {
          gridColumnStart: 1
        },
        '@media (max-width: 1000px)': {
          gridTemplateColumns: 'repeat(3, 1fr)'
        },
        '@media (max-width: 800px)': {
          gridTemplateColumns: 'repeat(2, 1fr)'
        },
        '@media (max-width: 600px)': {
          gridTemplateColumns: '1fr'
        }
      }}>
        {summaries.map((summary) => (
          <WriteoffDashboardCard 
            key={summary.type}
            summary={summary} 
            company={company}
            center={center}
          />
        ))}
      </Box>
    </Box>
  );
};
